<app-categories-refinement-list-contents *ngIf="state?.items"
                                         [items]="state!.items"
                                         (refine)="toggleItem($event)"
></app-categories-refinement-list-contents>

<app-button theme="link"
            size="smaller"
            layout="label-icon"
            [icon]="state?.isShowingMore ? 'chevron-up' : 'chevron-down'"
            (clicked)="state?.toggleShowMore()"
>
    <span [hidden]="state?.isShowingMore">{{ 'products.show-more' | translate }}</span>
    <span [hidden]="! state?.isShowingMore">{{ 'products.show-less' | translate }}</span>
</app-button>
